export default __webpack_public_path__ + "static/media/ic-package-inactive.18b26380.webp";